import { ACCOUNTS } from "../shared/tagTypes";
import { baseApi } from "./base";

const accountApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [ACCOUNTS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getAccounts: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/accounts`,
                    params: {
                        ...(payload.ledgerTypeId && {
                            ledgerTypeId: payload.ledgerTypeId,
                        }),
                        ...(payload.parentId && {
                            parentId: payload.parentId,
                        }),
                        ...(payload.status && {
                            status: payload.status,
                        }),
                        ...(payload.isGroup != null && {
                            isGroup: payload.isGroup,
                        }),
                    },
                }),
                providesTags: [ACCOUNTS],
            }),
            getAccount: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/accounts/${payload.id}`
                }),
                providesTags: [ACCOUNTS],
            }),
            createAccount: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/accounts`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [ACCOUNTS],
            }),
            updateAccount: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/accounts/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [ACCOUNTS],
            }),
            deleteAccount: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/accounts/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [ACCOUNTS],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetAccountsQuery,
    useLazyGetAccountsQuery,
    useGetAccountQuery,
    useLazyGetAccountQuery,
    useCreateAccountMutation,
    useUpdateAccountMutation,
    useDeleteAccountMutation
} = accountApi;
